import { render, staticRenderFns } from "./AssistanceDetails.vue?vue&type=template&id=59c4e55a&scoped=true"
import script from "./AssistanceDetails.vue?vue&type=script&lang=js"
export * from "./AssistanceDetails.vue?vue&type=script&lang=js"
import style0 from "./AssistanceDetails.vue?vue&type=style&index=0&id=59c4e55a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4e55a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c4e55a')) {
      api.createRecord('59c4e55a', component.options)
    } else {
      api.reload('59c4e55a', component.options)
    }
    module.hot.accept("./AssistanceDetails.vue?vue&type=template&id=59c4e55a&scoped=true", function () {
      api.rerender('59c4e55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/AssistanceDetails.vue"
export default component.exports